import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const AppleConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.APPLE}
    flow="clientConnect"
    redirectPath={paths.auth.appleClientConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccess"
  />
)
